var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsappDiv"},[_c('a',{staticClass:"whatsappDivWrappwe",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openWhatsapp.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/img/services/whatsapp.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }